import { c as _c } from "react/compiler-runtime";
export const ReviewIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="14" height="10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.66 7.167c0-1.213-.81-2.183-2.062-2.183-.283 0-.526.04-.768.161.04-1.414.768-2.465 2.668-3.274L12.73.052C9.05 1.225 7.798 3.53 7.798 6.277c0 1.82.89 3.396 3.072 3.396 1.617 0 2.79-1.051 2.79-2.506Zm-7.115 0c0-1.213-.808-2.183-2.061-2.183-.283 0-.526.04-.768.161.04-1.414.768-2.465 2.667-3.274L5.615.052C1.937 1.225.685 3.53.685 6.277c0 1.82.888 3.396 3.071 3.396 1.617 0 2.79-1.051 2.79-2.506Z" fill="#3C4858" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};